import { rtdb, messaging, auth } from '@/plugins/firebase'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['_user', '_pushToken', '_vapidKeyUsed'])
  },
  mounted () {
    if (this._user.isAnonymous) return
    if (!messaging) return

    var authWatch = auth.onAuthStateChanged(user => {
      this.messagingMessage = 'inside auth watch'
      if (user) {
        // Add the public key generated from the console here.
        if (!this._vapidKeyUsed) {
          // messaging.usePublicVapidKey('BAYT3aWIBXxkC6Cg0hnqg2nTand3sf9aGEMBAFryXSP1K-wTXbX8ejC0_lrGxgiRgIIBgiusyWj3KlMb1M5pECo')
          messaging.usePublicVapidKey(process.env.VUE_APP_FB_VAPIDKEY)

          this.$store.commit('set_vapidKeyUsed', true)
        }

        var sendTokenToServer = (currentToken) => {
          if (!this._pushToken) {
            this.messagingMessage = 'Sending token to server...'
            // TODO(developer): Send the current token to your server.
            rtdb.ref(`users/console/${this._user.uid}/preferences/push/tokens/${currentToken}`).set({ active: true })
            this.$store.commit('set_pushToken', currentToken)
          } else {
            this.messagingMessage = 'Token already sent to server so won\'t send it again ' + 'unless it changes'
          }
          this.$store.commit('set_pushToken', currentToken)
        }

        Notification.requestPermission().then((permission) => {
          if (permission === 'granted') {
            messaging.getToken()
              .then((currentToken) => {
                if (currentToken) {
                  sendTokenToServer(currentToken)
                } else {
                  // Show permission request.
                  this.$store.commit('set_pushToken', null)
                }
              })
              .catch((err) => {
                console.error(err)
                // showToken('Error retrieving Instance ID token. ', err);
                this.$store.commit('set_pushToken', null)
              })
          } else {
            // console.log('Unable to get permission to notify.')
          }
        })

        messaging.onTokenRefresh(() => {
          messaging.getToken().then((refreshedToken) => {
            // Indicate that the new Instance ID token has not yet been sent to the
            // app server.
            this.$store.commit('set_pushToken', null)
            // Send Instance ID token to app server.
            sendTokenToServer(refreshedToken)
            // ...
          }).catch((err) => {
            console.error(err)
          })
        })

        messaging.onMessage((payload) => {
          console.log('Message received. ', payload)
          var options = {
            body: payload.notification.body,
            icon: payload.notification.icon,
            tag: payload.notification.tag
          }

          const NOTIFICATION = new Notification(payload.notification.title, options)

          NOTIFICATION.onclick = () => {
            console.log(payload.notification.path)
            this.$router.push(payload.notification.path)
          }
        })

        self.addEventListener('notificationclick', (event) => {
          console.log(event)
          // if (event.action === 'like') {
          //   // Like button was clicked
          //   const photoId = event.notification.data.photoId;
          //   // like(photoId);
          //   console.log('you liked photo '. photoID);
          // }
          // else if (event.action === 'unsubscribe') {
          //   // Unsubscribe button was clicked
          //   const notificationType = event.notification.data.notificationType;
          //   // unsubscribe(notificationType);
          //   console.log('you unsubscribed', notificationType);
          // }
          event.notification.close()
        })

        authWatch()
      }
    })

    // Get Instance ID token. Initially this makes a network call, once retrieved
    // subsequent calls to getToken will return from cache.
    // var title = 'lunch'
    // var img = '/to-do-notifications/img/icon-128.png';
    // var text = 'HEY! Your task "' + title + '" is now overdue.';
    // var notification = new Notification('To do list', { body: text, icon: img });
  }
}
